import { render, staticRenderFns } from "./CustomDisplayElementExpandItem.vue?vue&type=template&id=a26610de&scoped=true&lang=html"
import script from "./CustomDisplayElementExpandItem.vue?vue&type=script&lang=js"
export * from "./CustomDisplayElementExpandItem.vue?vue&type=script&lang=js"
import style0 from "./CustomDisplayElementExpandItem.vue?vue&type=style&index=0&id=a26610de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26610de",
  null
  
)

export default component.exports